import { UiMarkdownModel } from "../../models";

export function mockUiMarkdownModel({
    id = "markdown-1234",
    type = "uiMarkdown",
    locale = "en",
    content = mockUiMarkdownModelContent()
}: Partial<UiMarkdownModel> = {}): UiMarkdownModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiMarkdownModelContent = UiMarkdownModel["content"];

export function mockUiMarkdownModelContent({
    ...optionals
}: Partial<UiMarkdownModelContent> = {}): UiMarkdownModelContent {
    return {
        ...optionals
    };
}
